import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import Layout from '../components/layout'
import Head from '../components/head'
import Form from '../components/form'
import CategoryFilter from '../components/CategoryFilter'
import ProductCard from '../components/ProductCard'

const Catalog = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCategorie {
        nodes {
          name
        }
      }
      allContentfulProduit {
        nodes {
          category {
            name
          }
          price
          pricePromo
          slug
          title
          image {
            fluid(maxHeight: 350, maxWidth: 450) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          id
        }
      }
    }
  `)
  const [selectedCategory, setSelectedCategory] = useState('All')
  const [allProducts, setAllProducts] = useState(
    data.allContentfulProduit.nodes
  )
  const [selectedProducts, setSelectedProducts] = useState(
    data.allContentfulProduit.nodes
  )

  useEffect(() => {
    if (selectedCategory === 'All') {
      setSelectedProducts(allProducts)
    } else if (selectedCategory === 'Promos') {
      const newSelection = [...allProducts].filter(
        item => item.pricePromo !== null
      )
      setSelectedProducts(newSelection)
    } else {
      const newSelection = [...allProducts].filter(
        item => item.category.name === selectedCategory
      )
      setSelectedProducts(newSelection)
    }
  }, [selectedCategory])

  const handleCategoryChange = function(e) {
    setSelectedCategory(e.target.value)
  }
  return (
    <Layout>
      <Head
        title="Catalogue des produits de Baby-commerce"
        description="Un exemple de la page des produits d'un site e-commmerce avec Gatsby JS, Contentful et Snipcart"
      />
      <h2 className="mb-2 mt-section">
        Découvrez tous les produits de Baby-commerce en exclusivité
      </h2>
      <CategoryFilter
        categories={data.allContentfulCategorie.nodes}
        active={selectedCategory}
        handleClick={handleCategoryChange}
      />
      <section className="padding section--highlights full-width bg-light-gray">
        <div className="grid-container">
          <div className="highlights--container">
            {selectedProducts.map(product => {
              return <ProductCard key={product.slug} product={product} />
            })}
          </div>
        </div>
      </section>

      <Form />
    </Layout>
  )
}

export default Catalog
